import { AxiosPromise } from 'axios';
import { PrebuildModule } from '@dev/ee-api/ee-api-models';
import { request } from './request';

export const loadPrebuildModules = (): AxiosPromise<PrebuildModule[]> => {
    const { Accounts } = request();
    return Accounts.accountsDashboardsettingsPrebuildmodulesGet();
};

export const updatePrebuildModuleName = (
    name: string,
    newName: string,
): AxiosPromise<PrebuildModule[]> => {
    const { Accounts } = request();
    return Accounts.accountsDashboardsettingsPrebuildmodulesByNamePatch(name,newName);
};

export const addPrebuildModule = (prebuildmodule: PrebuildModule, screenshotWidth?: number, screenshotHeight?: number): AxiosPromise<PrebuildModule[]> => {
    const { Accounts } = request();
    return Accounts.accountsDashboardsettingsPrebuildmodulePost(prebuildmodule, screenshotWidth, screenshotHeight);
};

export const deletePrebuildModule = (
    name: string
): AxiosPromise<PrebuildModule[]> => {
    const { Accounts } = request();
    return Accounts.accountsDashboardsettingsPrebuildmodulesByNameDelete(name);
};
